<template>
  <div class="recharge">
    <navbar>
      <template #left>
        <!-- <span class="material-icons">chevron_left</span> -->
        <svg t="1748487155504" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg"
          p-id="21829" width=".6rem" height=".6rem">
          <path
            d="M637.5424 231.2192c22.8352 22.3232 24.6272 53.4016 0 80.6912l-191.8464 200.0896 191.8464 200.0896c24.6272 27.2896 22.8352 58.4192 0 80.5888-22.784 22.3232-61.2864 20.8896-82.688 0-21.4016-20.7872-230.5024-240.384-230.5024-240.384-11.4176-11.1104-17.152-25.7024-17.152-40.2944s5.7344-29.184 17.152-40.3968c0 0 209.1008-219.4944 230.5024-240.384s59.904-22.3232 82.688 0z"
            fill="#ffffff" p-id="21830"></path>
        </svg>
      </template>
      <template #title>
        <span style="color: #fff;font-size: .4267rem;">
          {{ $t('user.t41') }}
        </span>
      </template>
      <template #right>
        <!-- <span class="material-icons" @click="$router.push('/serve')">support_agent</span> -->
        <svg @click="$router.push('/serve')" t="1748486049022" class="icon" viewBox="0 0 1046 1024" version="1.1"
          xmlns="http://www.w3.org/2000/svg" p-id="11906" width=".6rem" height=".6rem">
          <path
            d="M907.377778 521.398044c0-234.245689-181.771378-393.398044-384-393.398044-200.112356 0-384 155.739022-384 395.946667A83.968 83.968 0 0 0 96.711111 597.333333V682.666667A85.583644 85.583644 0 0 0 182.044444 768h42.666667V507.721956c0-165.114311 133.552356-298.666667 298.666667-298.666667s298.666667 133.575111 298.666666 298.689422v302.921956h-341.333333v85.333333h341.333333a85.583644 85.583644 0 0 0 85.333334-85.333333v-52.064711c25.167644-13.198222 42.666667-39.253333 42.666666-69.973334V590.506667c0-29.878044-17.499022-55.887644-42.666666-69.108623z"
            p-id="11907" fill="#fff"></path>
          <path
            d="M395.377778 597.333333a42.666667 42.666667 0 1 0 0-85.333333 42.666667 42.666667 0 0 0 0 85.333333zM651.377778 597.333333a42.666667 42.666667 0 1 0 0-85.333333 42.666667 42.666667 0 0 0 0 85.333333z"
            p-id="11908" fill="#fff"></path>
          <path
            d="M779.377778 470.607644c-20.48-121.605689-126.293333-214.607644-253.860978-214.607644-129.274311 0-268.379022 107.087644-257.297067 275.205689 105.403733-43.099022 184.775111-136.965689 207.371378-251.312356 55.887644 112.207644 170.666667 189.44 303.786667 190.714311z"
            p-id="11909" fill="#fff"></path>
        </svg>
      </template>
    </navbar>
    <div class="content">
      <div class="title">
        {{ $t('user.t45') }}
      </div>
      <div class="ipt">
        <input type="text" placeholder="00.00" v-model="price">
      </div>
      <div class="list">
        <div class="item" v-for="(item, index) in rechargeList" :key="item.price" :class="{ 'color': idx === index }"
          @click="handleClicklist(index, item.price)">
          <div class="price">{{ item.price.toFixed(2) }}</div>
        </div>
      </div>
      <div class="btn" @click="handleClickBtn">
        <span class="material-icons">
          payment
        </span>
        {{ $t('user.t41') }}
      </div>
      <div class="hint">
        <p class="text"><span>*</span>1. The payment amount must be the same as the
          order
          amount, otherwise it will not arrive automatically<br><span>*</span>2. if you do not receive
          recharge and
          withdrawal, please consult your supervisor to solve other problems .<br></p>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'Recharge',
  data() {
    return {
      rechargeList: [
        {
          price: 100
        },
        {
          price: 300
        },
        {
          price: 500
        },
        {
          price: 1000
        },
        {
          price: 3000
        },
        {
          price: 5000
        },
        {
          price: 10000
        },
        {
          price: 20000
        },
        {
          price: 50000
        },
        {
          price: 100000
        }
      ],
      idx: -1,
      price: ''
    }
  },
  created() {

  },
  methods: {
    handleClicklist(index, price) {
      this.idx = index;
      this.price = price
    },
    handleClickBtn() {
      if (!this.price) {
        this.$toast(this.$t('user.t82'))
        return
      }
      this.$store.commit('SET_LOADING', true); // 打开loadingType
      this.$http.setRecharge({
        price: this.price
      }).then(res => {
        // 翻译
        this.$toast(this.$t('user.t57') + '...')
        if (res.code === 0) {
          setTimeout(() => {
            this.$router.push('/serve')
          }, 1500)
        } else {
          this.$toast(res.info)
        }
        // if (res.info.id) {
        //   this.$toast(this.$t('user.t47'))
        //   this.price = ''
        // }
      }).finally(() => {
        this.$store.commit('SET_LOADING', false);
      })
    }
  }
}
</script>
<style lang="less" scoped>
.recharge {
  .material-icons {}

  span {}

  .content {
    padding: 0 .4rem;

    .title {
      text-align: center;
      color: #fff;
      margin-top: .4267rem;
      margin-bottom: .1067rem;
    }

    .ipt {
      input {
        text-align: center;
        margin-bottom: .2rem;
        display: block;
        width: 100%;
        height: 1rem;
        background-color: #121212;
        border-radius: .1333rem;
        padding: .2133rem .4267rem;
        color: #fff;
        font-size: .45rem;
        box-sizing: border-box;

        &::placeholder {
          text-align: center;
        }
      }
    }

    .list {
      display: flex;
      flex-wrap: wrap;
      justify-content: center;

      .item {
        width: calc(50% - .2267rem);
        text-align: center;
        margin-bottom: .2rem;
        background-color: #fff;
        margin-right: .2267rem;
        padding: .4267rem;
        border-radius: .1067rem;

        &:nth-child(2n) {
          margin-right: 0;
        }

        .price {
          font-size: .4rem;
          color: #000;
        }
      }

      .color {}
    }

    .btn {
      display: flex;
      align-items: center;
      justify-content: center;
      color: #fff;
      background-color: #121212;
      margin-top: .2rem;
      padding: .16rem .32rem;
      border-radius: .1rem;
      border: 1px solid #fff;
    }

    .hint {
      padding: .4rem;
      background-color: #fff;
      margin-top: .4rem;
      border-radius: .2667rem;

      .text {
        font-size: .32rem;
        color: #666666;
        opacity: .7;
      }
    }
  }
}

.color {
  background-color: #dbc7ea !important;
}
</style>
